import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import StoreAnnouncementBannerForm from '@/components/v2/StoreAnnouncementBannerForm.vue';
import storeAnnouncementBannerCreate from '@/plugins/graphql/mutations/v2/store-announcement-banner-create.gql';
import StoreAnnouncementBanners from '@/plugins/graphql/queries/v2/store-announcement-banners.gql';
import StoreAnnouncementBannerMixin from '@/helpers/vue_mixins/v2/ecommerce/StoreAnnouncementBannerMixin';
import ImageUploadMixin from '@/helpers/vue_mixins/v2/ImageUploadMixin';
let StoreAnnouncementBannerCreate = class StoreAnnouncementBannerCreate extends Mixins(AlertMixin, RouterParamsAppMixin, StoreAnnouncementBannerMixin, PaginatorMixin, Mixins(ImageUploadMixin, CleverTapEventsMixin)) {
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.create(form)
            .then(() => {
            this.successNotification('Store Announcement Banner created successfully.');
            this.goToStoreAnnouncementBannerPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async create(form) {
        const inputImages = form.images.map((input) => input.file);
        const appUuid = this.appUUID;
        return this.$apollo.mutate({
            mutation: storeAnnouncementBannerCreate,
            variables: {
                input: {
                    appUuid,
                    announcementText: form.announcementText,
                    bgColor: form.bgColor,
                    active: form.active,
                    startAt: new Date(`${form.startAt}T${form.startAtTime}`),
                    endAt: new Date(`${form.endAt}T${form.endAtTime}`),
                    images: inputImages,
                },
            },
            update: (cache, { data }) => {
                const queryOptions = {
                    query: StoreAnnouncementBanners,
                    variables: {
                        appUuid,
                        first: this.perPage,
                        after: null,
                    },
                };
                const { fetchAllStoreAnnouncementBanners } = cache.readQuery({
                    ...queryOptions,
                });
                if (!fetchAllStoreAnnouncementBanners) {
                    return;
                }
                const cachedStoreAnnouncementBanners = {
                    ...fetchAllStoreAnnouncementBanners,
                };
                cachedStoreAnnouncementBanners.edges.unshift({
                    node: data.storeAnnouncementBannerCreate.storeAnnouncementBanner,
                    __typename: 'StoreAnnouncementBannerEdges',
                });
                cache.writeQuery({
                    ...queryOptions,
                    data: {
                        fetchAllStoreAnnouncementBanners: cachedStoreAnnouncementBanners,
                    },
                });
            },
        });
    }
};
StoreAnnouncementBannerCreate = __decorate([
    Component({
        components: {
            PageTitle,
            StoreAnnouncementBannerForm,
        },
    })
], StoreAnnouncementBannerCreate);
export default StoreAnnouncementBannerCreate;
